<template>
  <div class="relative w-full">
    <nav
      v-if="isProductsEnabled"
      class="flex justify-between"
      aria-label="Tabs"
    >
      <template
        v-for="tab in productsEnabledTabs"
        :key="tab.label"
      >
        <RouterLink
          #default="{ isActive }"
          :to="tab.to"
          custom
        >
          <div class="flex-1">
            <div
              :class="[
                isActive
                  ? 'text-background-fg/100'
                  : 'text-background-fg/70 hover:opacity-80',
                'line-clamp-1 flex flex-col items-center justify-center px-4 py-3 text-center text-sm font-medium',
              ]"
              :aria-current="isActive ? 'page' : undefined"
              @click="onTabClick(tab)"
            >
              {{ tab.label }}
            </div>
            <div
              :class="[
                isActive
                  ? 'bg-primary'
                  : 'bg-background-fg/20',
                'h-0.5 w-full rounded-full',
              ]"
            />
          </div>
        </RouterLink>
      </template>
    </nav>
    <div v-else>
      <div
        :class="[
          'text-background-fg/100',
          'line-clamp-1 flex flex-col items-center justify-center px-4 py-3 text-center font-semibold',
        ]"
      >
        {{ tenantName }}
      </div>
      <div
        :class="['bg-primary', 'h-0.5 w-full rounded-full']"
      />
    </div>

    <CashierQuickSwitchButton
      v-if="isCashiersEnabled"
      class="absolute inset-y-2 right-2"
    />
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationAsRelative } from "vue-router"

const {
  isProductsEnabled,
  isCashiersEnabled,
  name: tenantName,
} = useTenant()
const router = useRouter()
const { setDefaultTillRoute } = useDefaultTillRoute()

type Tab = {
  to: RouteLocationAsRelative
  label: string
}

const productsEnabledTabs: Array<Tab> = [
  {
    to: {
      name: "quickTill",
    },
    label: "Till",
  },
  {
    to: {
      name: "fullTill",
    },
    label: "Products",
  },
]

const onTabClick = (tab: Tab) => {
  if (isProductsEnabled.value) {
    setDefaultTillRoute(tab.to.name ?? "")
  }

  router.push(tab.to)
}
</script>
